import script from "./CustomResourceApplyDX.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplyDX.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplyDX.vue?vue&type=style&index=0&id=1fc2561a&lang=less&scope=true"

const __exports__ = script;

export default __exports__